<div class="wrapper-landing-blogs-page">
  <div class="zc-container">
    <div class="grid">
      <div class="grid__s-12">
        <span class="small-title">Blog</span>
      </div>
    </div>
    <div *ngIf="featuredBlog" class="grid">
      <div class="grid__s-8">
        <div class="wrapper-card-blog large">
          <div class="wrapper-header-card-blog">
            <img [src]="featuredBlog.image.full_path" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label" [ngClass]="featuredBlog.category | lowercase">
                <span>{{featuredBlog.category}}</span>
              </div>
              <span class="time-card-blog">{{ featuredBlog.created_at | timeAgo }}</span>
            </div>
            <span class="title-landing-blog-card">{{featuredBlog.title}}</span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, featuredBlog.id]">Pročitaj...</span>
          </div>
        </div>
      </div>
      <div class="grid__s-4">
        <div class="wrapper-banner-blog responsive-banner-blog">
          <div *ngIf="banner" class="wrapper-image-banner" [ngStyle]="{'background-image': 'url(' + banner.image.full_path + ')'}"></div>
          <div *ngIf="!banner" class="wrapper-banner-empty">
            <img class="yellow-icon-banner" src="../../../../assets/icons/landing/illustration/illustration-yellow-empty-banner.svg" alt="">
            <img class="r-empty-banner" src="../../../../assets/icons/landing/illustration/illustration-r-empty-banner.svg" alt="">
            <div class="content-empty-banner responsive-blog">
              <img src="../../../../assets/icons/landing/illustration/white-r.svg" alt="">
              <span>Mesto za</span>
              <span><b>Vašu reklamu!</b></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid">
      <div *ngFor="let blog of blogs" class="grid__m-4">
        <div class="wrapper-card-blog">
          <div class="wrapper-header-card-blog">
            <img [src]="blog.image.full_path" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label" [ngClass]="blog.category | lowercase">
                <span>{{blog.category}}</span>
              </div>
              <span class="time-card-blog">{{ blog.created_at | timeAgo }}</span>
            </div>
            <span class="title-landing-blog-card length-character-column length-character-column--2">{{blog.title}}</span>
            <span class="subtitle-landing-blog-card length-character-column length-character-column--2" [innerHTML]="blog.intro_text"></span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, blog.id]">Pročitaj...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
